import React, { useRef } from 'react';

function formatTime(seconds) {
  if (!seconds || isNaN(seconds)) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export default function AudioPlayer({
  isPlaying, currentTime, duration, isLoading,
  onTogglePlay, onSeek, volume, onVolumeChange,
}) {
  const progressRef = useRef(null);

  const handleProgressClick = (e) => {
    if (!progressRef.current || !duration) return;
    const rect = progressRef.current.getBoundingClientRect();
    const ratio = (e.clientX - rect.left) / rect.width;
    onSeek(Math.max(0, Math.min(duration, ratio * duration)));
  };

  const progress = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div className="audio-player">
      {/* Progress bar */}
      <div className="player-timeline">
        <span className="player-time">{formatTime(currentTime)}</span>

        <div
          className="player-progress"
          ref={progressRef}
          onClick={handleProgressClick}
        >
          <div
            className="player-progress-fill"
            style={{ width: `${progress}%` }}
          />
          <div
            className="player-progress-thumb"
            style={{ left: `${progress}%` }}
          />
        </div>

        <span className="player-time">{formatTime(duration)}</span>
      </div>

      {/* Controls */}
      <div className="player-controls">
        {/* Volume */}
        <div className="player-volume">
          <span className="player-volume-icon">{volume === 0 ? '🔇' : volume < 0.5 ? '🔉' : '🔊'}</span>
          <input
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={volume}
            onChange={e => onVolumeChange(parseFloat(e.target.value))}
            style={{ width: 80 }}
          />
        </div>

        {/* Play/Pause */}
        <button
          className="player-btn-play"
          onClick={onTogglePlay}
          disabled={isLoading}
          title={isPlaying ? 'Pause' : 'Play'}
        >
          {isLoading ? (
            <span className="animate-spin" style={{ display: 'inline-block', fontSize: 18 }}>⏳</span>
          ) : isPlaying ? '⏸' : '▶'}
        </button>

        {/* Stop */}
        <button
          className="btn btn-icon"
          onClick={() => onSeek(0)}
          title="Restart"
        >
          ⏮
        </button>
      </div>
    </div>
  );
}
